import { render, staticRenderFns } from "./cookiePolicyTiger.vue?vue&type=template&id=b742eba2&scoped=true"
import script from "./cookiePolicyTiger.vue?vue&type=script&lang=js"
export * from "./cookiePolicyTiger.vue?vue&type=script&lang=js"
import style0 from "./cookiePolicyTiger.vue?vue&type=style&index=0&id=b742eba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b742eba2",
  null
  
)

export default component.exports